import { render, staticRenderFns } from "./business_card.vue?vue&type=template&id=37c3e996&scoped=true"
import script from "./business_card.vue?vue&type=script&lang=js"
export * from "./business_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c3e996",
  null
  
)

export default component.exports